import React from 'react';
import wb0 from '../img/Detail/campus_detail.jpg';
import './Detail.css';
const CampusDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default CampusDetail;